import axiosInstance from '../services/AxiosInstance';

export function getCustomers(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    let url = 'customer?';
    const params = [];
    if (typeof pageNum !== 'undefined' && typeof pageSize !== 'undefined') {
        params.push(`pageNum=${pageNum}`);
        params.push(`pageSize=${pageSize}`);
    }
    if (filterQuery) {
        params.push(filterQuery);
    }
    url += params.join('&');
    return axiosInstance.get(url);
}

export function getReportCustomers( filterQuery = "") {
    return axiosInstance.get(`customer?noPagination=true&${filterQuery}`);
}

export function deleteCustomer(id) {
    return axiosInstance.delete(`customer/${id}`);
}

export function createCustomer(data) {
    return axiosInstance.post(`customer`,data);
}

export function updateCustomer(id, data) {
    return axiosInstance.put(`customer/${id}`,data);
}
